module.exports = __webpack_public_path__ + "static/img/5.824fb3dc.png";